import { useState } from "react";
import "@/App.css";
import { translations } from "@/translations";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import KvinneBadge from "@/components/site/KvinneBadge";
import StickyCTA from "@/components/site/StickyCTA";

function App() {
  const [lang, setLang] = useState("no");
  const t = translations[lang];

  return (
    <div className="App bg-[#F8F9FA] text-[#0A0F1C] min-h-screen" lang={lang}>
      <Header t={t} lang={lang} setLang={setLang} />
      <main>
        <Hero t={t} />
        <Services t={t} />
        <About t={t} />
        <Gallery t={t} />
        <Testimonials t={t} />
        <Contact t={t} lang={lang} />
      </main>
      <Footer t={t} />
      <KvinneBadge topText={t.badge.top} bottomText={t.badge.bottom} />
      <StickyCTA t={t} />
    </div>
  );
}

export default App;
